import { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useFormik } from 'formik';
import * as Yup from 'yup';

import { useDispatch, useSelector } from 'react-redux';
import { errorHelper, Loader } from '../../utils/tools'

import { Button, Form, Image } from 'react-bootstrap';
import { HiEye, HiEyeOff } from 'react-icons/hi';

import { signInUser } from '../../store/actions/users';
import PreventSignIn from '../../hoc/preventSignIn';

// CSS styles
import '../../styles/style.css';
import '../../styles/tenantSetup.css';

// Assets
import logo from '../../assets/logo.svg';

const Auth = () => {

    let navigate = useNavigate();

    const [showPassword, setShowPassword] = useState(false);

    // Redux logic
    const users = useSelector(state => state.users);
    const notifications = useSelector(state => state.notifications);
    const dispatch = useDispatch();

    const formik = useFormik({
        initialValues: {emailOrUsername: '', password: ''},
        validationSchema: Yup.object({
            emailOrUsername: Yup.string()
            .required('Zadajte prihlasovacie meno, alebo e-mail.'),
            password: Yup.string()
            .required('Zadajte heslo.')
        }),
        // na submit posielame  hodnoty  do funkcie kde nasledne volame funkciu handlesubmit 
        // so vstupnymi parametrami values
        onSubmit: (values) => {
            handleSubmit(values)
        }
    })

    // funkcia handle submit prebera na vstup values z onSubmit 
    const handleSubmit = (values) => {
            dispatch(signInUser(values));
    }

    useEffect(()=>{
        if(notifications && notifications.global.success){
            navigate('/dashboard')
        }
    },[notifications, navigate])

    return(
        <PreventSignIn users={users}>
            { users.loading ? (
                <div className="centered-loader"><Loader/></div>
            ) : (
                <div className="onboarding-overlay">

                    <div className="onboarding-left">
                        <div className="onboarding-left-content">
                            <div style={{ display: 'flex', gap: '8px', marginBottom: '24px', flexWrap: 'wrap' }}>
                                <span style={{ background: 'rgba(255,255,255,0.12)', border: '1px solid rgba(255,255,255,0.25)', borderRadius: '20px', padding: '4px 14px', fontSize: '0.78rem', color: '#fff', fontWeight: 500, letterSpacing: '0.02em' }}>Evidencia odpadov</span>
                                <span style={{ background: 'rgba(99,179,237,0.15)', border: '1px solid rgba(99,179,237,0.4)', borderRadius: '20px', padding: '4px 14px', fontSize: '0.78rem', color: '#90cdf4', fontWeight: 500, letterSpacing: '0.02em' }}>PPWR</span>
                            </div>
                            <h2>Plný súlad s legislatívou.<br/>Jednoducho a efektívne.</h2>
                            <p>Komplexná platforma pre evidenciu odpadov aj reporting obalov podľa nariadenia PPWR – všetko na jednom mieste.</p>
                            <ul style={{ listStyle: 'none', padding: 0, margin: '20px 0 0 0' }}>
                                {[
                                    'Evidenčné listy a ohlasovanie odpadov',
                                    'Správa skladov a tok odpadov',
                                    'PPWR – evidencia a reporting obalov',
                                    'Exporty a štatistiky pre úrady',
                                ].map((item, i) => (
                                    <li key={i} style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px', fontSize: '0.9rem', color: 'rgba(255,255,255,0.88)' }}>
                                        <span style={{ width: '20px', height: '20px', borderRadius: '50%', background: 'rgba(255,255,255,0.12)', border: '1px solid rgba(255,255,255,0.2)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, fontSize: '0.65rem' }}>✓</span>
                                        {item}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>

                    <div className="onboarding-right auth-right">
                        <Image src={logo} style={{ height: '32px', width: 'auto', position: 'absolute', top: '32px', right: '48px' }} />

                        <div className="auth-form-inner">
                            <div className="mb-4">
                                <h1>Prihlásenie</h1>
                                <p style={{ color: '#718094' }}>Vitajte späť! Prihláste sa pomocou svojich údajov.</p>
                            </div>

                            <Form onSubmit={formik.handleSubmit}>
                                <Form.Group className="mb-3" controlId="formBasicEmail">
                                    <Form.Label>Prihlasovacie meno alebo e-mail</Form.Label>
                                    <Form.Control
                                        type="text"
                                        className="radius"
                                        placeholder="Zadajte e-mail alebo meno:"
                                        {...formik.getFieldProps('emailOrUsername')}
                                        isInvalid={errorHelper(formik, 'emailOrUsername').error}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {errorHelper(formik, 'emailOrUsername').helperText}
                                    </Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group className="mb-3" controlId="formBasicPassword">
                                    <Form.Label>Heslo</Form.Label>
                                    <div style={{ position: 'relative' }}>
                                        <Form.Control
                                            type={showPassword ? 'text' : 'password'}
                                            className="radius"
                                            placeholder="Zadajte heslo:"
                                            style={{ paddingRight: '2.5rem', backgroundImage: 'none' }}
                                            {...formik.getFieldProps('password')}
                                            isInvalid={errorHelper(formik, 'password').error}
                                        />
                                        <span
                                            onClick={() => setShowPassword(p => !p)}
                                            style={{ position: 'absolute', top: '50%', right: '0.75rem', transform: 'translateY(-50%)', cursor: 'pointer', color: '#6c757d', zIndex: 5 }}
                                        >
                                            {showPassword ? <HiEyeOff size={18} /> : <HiEye size={18} />}
                                        </span>
                                    </div>
                                    <Form.Control.Feedback type="invalid" style={{ display: errorHelper(formik, 'password').error ? 'block' : 'none' }}>
                                        {errorHelper(formik, 'password').helperText}
                                    </Form.Control.Feedback>
                                </Form.Group>

                                <Button variant='primary' type="submit" size="lg" className="full-width button-custom-large radius">
                                    Prihlásiť sa
                                </Button>
                            </Form>

                            <p className="auth-register-hint" style={{ marginTop: '12px' }}>
                                <Link to="/account/forgot-password" className="auth-register-link">
                                    Zabudli ste heslo?
                                </Link>
                            </p>

                            <p className="auth-register-hint">
                                Nemáte účet?{' '}
                                <Link to="/account/register" className="auth-register-link">
                                    Zaregistrujte sa
                                </Link>
                            </p>
                        </div>
                    </div>

                </div>
            )}
        </PreventSignIn>
    )
}

export default Auth;
